module.exports = __webpack_public_path__ + "static/img/4.b77eb2d1.png";